import { spawnPotion, makeKey, makeWeapon, makeArmor, makeFood } from "../items/ItemFactory.js";

/**
 * Home crafting recipes. Each consumes COPPER FUEL (the blacksmith reserve, the
 * same sink as forging) plus GOLD, and outputs a consumable, a Vault Key, or a
 * fresh piece of gear scaled to your current depth. Some recipes are gated behind
 * research nodes. This turns copper + gold into a between-runs sink and gives the
 * deep economy a reason to hoard materials.
 *
 * `make(game)` builds the item (scaled to game.floor). `model` is the registry
 * key used to render the output's real 3D thumbnail in the UI (no emoji). `req`
 * is an optional research id. `banksKey` items go to the key counter, not the bag.
 */
export const RECIPES = [
  { id: "potion_hp", name: "Health Potion", model: "potion/health", copper: 2, gold: 15, req: null,
    desc: "Restores health in a pinch.", make: (g) => spawnPotion("hp", g.floor) },
  { id: "potion_mana", name: "Mana Potion", model: "potion/health", copper: 3, gold: 20, req: null,
    desc: "Restores mana for casters.", make: (g) => spawnPotion("mana", g.floor) },
  { id: "potion_hp_g", name: "Greater Potion", model: "potion/greater", copper: 5, gold: 40, req: "surv_2",
    desc: "A potent heal. Requires Provisioning II.", make: (g) => spawnPotion("hp_greater", g.floor) },
  { id: "potion_mana_g", name: "Greater Mana Potion", model: "potion/greater", copper: 5, gold: 40, req: "surv_2",
    desc: "A deep draught of mana. Requires Provisioning II.", make: (g) => spawnPotion("mana_greater", g.floor) },
  { id: "ration", name: "Trail Ration", model: "food/burger", copper: 2, gold: 18, req: null,
    desc: "A hearty meal — heals and grants a stacking buff.", make: () => makeFood() },
  { id: "vault_key", name: "Vault Key", model: "relic/key_gold", copper: 6, gold: 50, req: null, banksKey: true,
    desc: "Forge a key to crack open locked chests and vault doors.", make: () => makeKey(1) },
  { id: "forge_weapon", name: "Forged Weapon", model: "weapon/sword", copper: 10, gold: 120, req: "forge_1",
    desc: "A random Uncommon+ weapon for your depth. Requires Apprentice Smithing.", make: (g) => makeWeapon(g.floor, 1) },
  { id: "forge_armor", name: "Forged Armor", model: "weapon/shield", copper: 10, gold: 120, req: "armorsmith",
    desc: "A random Uncommon+ armor for your depth. Requires Armoursmithing.", make: (g) => makeArmor(g.floor, 1) },
  { id: "rare_cache", name: "Rare Weapon Cache", model: "weapon/sword2", copper: 16, gold: 200, req: "forge_2",
    desc: "A guaranteed Rare+ weapon for your depth. Requires Journeyman Smithing.", make: (g) => makeWeapon(g.floor, 2) },
];

export function recipeById(id) { return RECIPES.find((r) => r.id === id) || null; }
